import { useEffect, useState } from "react";
import { Trash2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Admins() {
  const { user } = useAuth();
  const [admins, setAdmins] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const load = () => api.get("/admin/users").then((r) => setAdmins(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/users", form);
      toast.success("Administrador cadastrado");
      setForm({ name: "", email: "", password: "" });
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (a) => {
    if (!window.confirm(`Remover ${a.name}?`)) return;
    try { await api.delete(`/admin/users/${a.id}`); toast.success("Administrador removido"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-8">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primo-500">Equipe</p>
        <h1 className="font-display text-4xl font-extrabold tracking-tight">Administradores</h1>
      </div>
      <div className="grid gap-6 lg:grid-cols-[1fr_360px]">
        <div className="space-y-2">
          {admins.map((a) => (
            <div key={a.id} data-testid={`admin-row-${a.email}`} className="flex items-center justify-between rounded-2xl border border-white/[0.08] bg-[#1A1A1A] p-4">
              <div>
                <p className="font-semibold">{a.name} {a.id === user?.id && <span className="ml-1 text-xs text-primo-400">(você)</span>}</p>
                <p className="text-sm text-slate-500">{a.email}</p>
              </div>
              {a.id !== user?.id && (
                <button data-testid={`delete-admin-${a.email}`} onClick={() => remove(a)} className="grid h-9 w-9 place-items-center rounded-lg text-red-400 hover:bg-red-500/20"><Trash2 className="h-4 w-4" /></button>
              )}
            </div>
          ))}
        </div>
        <form onSubmit={create} className="h-fit space-y-3 rounded-2xl border border-white/[0.08] bg-[#1A1A1A] p-5">
          <h2 className="flex items-center gap-2 font-display text-lg font-semibold"><UserPlus className="h-5 w-5 text-primo-400" /> Novo administrador</h2>
          <Input required data-testid="new-admin-name-input" placeholder="Nome" value={form.name} onChange={set("name")} />
          <Input required type="email" data-testid="new-admin-email-input" placeholder="E-mail" value={form.email} onChange={set("email")} />
          <Input required minLength={6} type="password" data-testid="new-admin-password-input" placeholder="Senha (mín. 6 caracteres)" value={form.password} onChange={set("password")} />
          <Button data-testid="new-admin-submit-button" className="w-full rounded-full font-bold">Cadastrar</Button>
        </form>
      </div>
    </div>
  );
}
